import React, { useState } from 'react'

import Agreement from './agreements'
import { AgreementProvider } from './agreements-context'

const AgreementPage: React.FC = () => {
  const [receivedData, setReceivedData] = useState([])
  const [modifiedAgreements, setModifiedAgreements] = useState([])
  const [collectiveAgreements, setCollectiveAgreements] = useState([])

  return (
    <AgreementProvider
      value={{
        receivedData,
        setReceivedData,
        modifiedAgreements,
        setModifiedAgreements,
        collectiveAgreements,
        setCollectiveAgreements,
      }}
    >
      <Agreement />
    </AgreementProvider>
  )
}

export default AgreementPage
